module.exports = __webpack_public_path__ + "img/behance-white.b41fcb65.svg";